import { DateTime } from 'luxon'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Rails from '@rails/ujs'
import React from 'react'

import Timer from '../Global/Timer'
import QuestionAttemptForm from '../QuestionAttempt/Form'

const QuizWrapper = styled.div`
  text-align: center;
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 100%;
`

const QuizBody = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const QuizHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  text-align: center;
  align-content: center;
  align-items: center;
  padding-top: 1em;
`

const QuizFooter = styled.div`
  text-align: center;
  margin-top: 1em;
`

const QuizTimer = styled.div`

`

const Heading2 = styled.h2`
  display: inline-block;
  width: 100%;
`

export default class QuizAttemptShow extends React.Component {
  static propTypes = {
    quiz_attempt: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)

    // How to set initial state in ES6 class syntax
    // https://reactjs.org/docs/state-and-lifecycle.html#adding-local-state-to-a-class
    this.state = {
      quizAttempt: this.props.quiz_attempt,
      timeSinceStartSeconds: Math.floor((DateTime.local() - DateTime.fromJSDate(new Date(this.props.quiz_attempt.start_time))) / 1000),
      timedOut: false
    }
  }

  setTimedOut = () => {
    this.setState({ timedOut: true })

    // Set timeout info on quiz attempt, reloading show will then
    // show results
    fetch(`/quiz_attempts/${this.state.quizAttempt.id}/timeout`, {
      method: 'PUT',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': Rails.csrfToken(),
        'Content-Type': 'application/json'
      },
      redirect: 'follow',
      credentials: 'same-origin'
    })
  }

  render() {
    let timeLimit = this.state.quizAttempt.quiz.time_limit ? this.state.quizAttempt.quiz.time_limit : 0

    if (this.state.timedOut) {
      return (
        <QuizWrapper>
          <QuizHeader>
            <Heading2>You ran out of time.</Heading2>
          </QuizHeader>
          <QuizBody>
            <div className="btn btn-primary"
                onClick={() => { window.location.reload(false) }}>
              View Results
            </div>
          </QuizBody>
          <QuizFooter>{ this.state.quizAttempt.quiz.title } - Timed Out</QuizFooter>
        </QuizWrapper>
      )
    }

    return (
      <QuizWrapper>
        <QuizHeader>
          <QuizTimer>
            <Timer startTimeSeconds={this.state.timeSinceStartSeconds }
                   timeLimit={timeLimit}
                   overLimitCallback={this.setTimedOut}
                   label={'Quiz'} />
          </QuizTimer>
        </QuizHeader>
        <QuizBody>
          <QuestionAttemptForm
            questionAttempt={this.state.quizAttempt.next_question_attempt}
            quiz={this.state.quizAttempt.quiz}
            totalQuestions={this.state.quizAttempt.total_questions} />
        </QuizBody>
        <QuizFooter>{ this.state.quizAttempt.quiz.title } - In Progress</QuizFooter>
      </QuizWrapper>
    )
  }
}
